import { Board, Partner, Society } from 'types';

const isEligibleParticipant = (board: Board, partnerId: string): boolean => {
  const participant = board?.participants?.find((p) => p.member === partnerId);

  if (!participant) {
    return false;
  }

  return !participant.isRepresented && (participant?.votes?.length || 0) === 0;
};

const getDelegationPartners = (
  board: Board,
  partners: Partner[],
  partnerId: string
): Partner[] =>
  partners.filter(
    (partner) =>
      board?.delegationPartners?.includes(partner['_id']) &&
      partner['_id'] !== partnerId &&
      isEligibleParticipant(board, partner['_id'])
  );

const getNotDelegationPartners = (
  board: Board,
  society: Society,
  partners: Partner[],
  partnerId: string
): Partner[] =>
  partners.filter((partner) => {
    const { hasOldPartnersOn } = society?.configuration || {};

    if (hasOldPartnersOn) {
      return (
        partner['_id'] !== partnerId && isEligibleParticipant(board, partner['_id'])
      );
    }
    return (
      partner['_id'] !== partnerId &&
      partner?.sharesCount?.actual > 0 &&
      isEligibleParticipant(board, partner['_id'])
    );
  });

export const getFilteredPartners = (
  board: Board,
  society: Society,
  partners: Partner[],
  partnerId: string
): Partner[] => {
  let filteredPartners = [];

  if (board?.delegationPartners && board?.delegationPartners?.length > 0) {
    filteredPartners = getDelegationPartners(
      board,
      partners,
      partnerId
    );
  } else {
    filteredPartners = getNotDelegationPartners(board, society, partners, partnerId);
  }

  return filteredPartners;
};
